"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListenerSO = void 0;
const react_1 = require("react");
const constants_1 = require("../utils/constants");
function useListenerSO() {
    const [eventData, setEventData] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const authResponse = (event) => {
            var _a, _b, _c, _d;
            if (event.origin !== window.origin)
                return;
            let eventData;
            try {
                eventData = JSON.parse(event.data);
            }
            catch (err) { }
            if (eventData && (eventData === null || eventData === void 0 ? void 0 : eventData.type) == constants_1.eventTypes.passMessage)
                setEventData(eventData);
            else if (eventData && (eventData === null || eventData === void 0 ? void 0 : eventData.type) == constants_1.eventTypes.saveToAuth) {
                localStorage.setItem('tempVault', (_a = eventData === null || eventData === void 0 ? void 0 : eventData.data) === null || _a === void 0 ? void 0 : _a.tempVault);
                localStorage.setItem('init', (_b = eventData === null || eventData === void 0 ? void 0 : eventData.data) === null || _b === void 0 ? void 0 : _b.init);
                localStorage.setItem(constants_1.TRIA_WALLET_STORE, (_c = eventData === null || eventData === void 0 ? void 0 : eventData.data) === null || _c === void 0 ? void 0 : _c.publicVault);
                localStorage.setItem('accessToken', (_d = eventData === null || eventData === void 0 ? void 0 : eventData.data) === null || _d === void 0 ? void 0 : _d.accessToken);
                setEventData(eventData);
            }
        };
        window.addEventListener('message', authResponse);
    }, []);
    return { eventData };
}
exports.useListenerSO = useListenerSO;
